import { IGroup } from "models/seoTrendingBlocks";

interface ISeoLinksProps {
  title: string;
  data: Array<IGroup>;
  className?: string;
}

const SeoLinks = (props: ISeoLinksProps) => {
  const { data, title } = props;
  return (
    <section
      id="seoNormalLinksHome"
      className="contentVisibilityHidden p-16 mt-32 lightGrayBg"
    >
      <h2 className="font-20 mb-16 pb-16 borderBottom">{title}</h2>
      <div className="flex">
        {(data || []).map((group, index) => (
          <div key={index} className="width-20">
            {group.group_link.length ? (
              <h3 className="mb-16 font-18">
                <a href={group.group_link} className="blackColor block">
                  {group.group_title}
                </a>
              </h3>
            ) : (
              <h3 className="mb-16 font-18">{group.group_title}</h3>
            )}
            <div>
              {group.links.map((data, index) => (
                <a key={index} href={data.link} className="blackColor block mb-16">
                  {data.title}
                </a>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default SeoLinks;
